import { BoxOffice } from 'features/BoxOffice';

const BoxOfficePage = (): JSX.Element => <BoxOffice />;

export default BoxOfficePage;
